import AccountingInfoOption from './AccountingInfoOption';

export default class CustomerPostingGroup extends AccountingInfoOption {
    public static entity = 'customerPostingGroups';
    public static apiType = 'customer-posting-groups';
    public static storageKey = 'customer_posting_groups_list';
}